import { createAction } from 'redux-actions';
import { callApi, getEndpoint } from '../../../utils/api';

const Add_Charity = 'ADD_CHARITY';
const Add_Gross_Amount = 'ADD_GROSS_AMOUNT';
const Delete_Charity = 'DELETE_CHARITY';
const Disclosure_Agree = 'DISCLOSURE_AGREE';
const Reduce_Auto_RMD = 'REDUCE_AUTO_RMD';
const Add_QCD_Fund = 'ADD_QCD_FUND';
const Delete_QCD_Fund = 'DELETE_QCD_FUND';
const QCD_Fund_Endpoint = 'QCD_FUND_ENDPOINT';
const Update_QCD_Amount = 'UPDATE_QCD_AMOUNT';
const QCD_SUBMIT = 'QCD_SUBMIT';
const RESET_QCD_SELECTED_FUND = 'RESET_QCD_SELECTED_FUND';
const QCD_PRINT = 'QCD_PRINT';
const GET_QCD_TRADE_DATES = 'GET_QCD_TRADE_DATES';

let currId = 0;

export default function qcd(
  state = {
    charities: {},
    checkbox: false,
    reduceAutoRMD: false,
    qcdSelectedFunds: {},
    iraQCDFunds: {},
    QCDSuccess: false,
    QCDFailure: false,
    QCDLoading: false,
    QCDTransactionSuccess: {},
    QCDPrintSuccess: false,
    QCDPrintFailure: false,
    QCDPrintPending: false,

    qcdTradeDates: {},
    qcdTradeDatesFailed: false,
    qcdTradeDatesSuccess: false,
    qcdTradeDatesLoading: false,
  },
  { payload, type }
) {
  switch (type) {
    case `${QCD_Fund_Endpoint}_PENDING`:
      return {
        ...state,
        iraQCDFunds: {
          isLoaded: false,
          isLoading: true,
        },
      };
    case `${QCD_Fund_Endpoint}_FULFILLED`:
      return {
        ...state,
        iraQCDFunds: {
          isLoaded: true,
          isLoading: false,
          funds: payload.body ? payload.body : [],
        },
      };

    case `${QCD_Fund_Endpoint}_REJECTED`:
      return {
        ...state,
        iraQCDFunds: {
          isLoaded: true,
          isLoading: false,
          hasError: true,
          funds: [],
          error: payload,
        },
      };
    case `${RESET_QCD_SELECTED_FUND}_FULFILLED`: {
      return {
        ...state,
        qcdSelectedFunds: {},
      };
    }
    case `${Add_Charity}_FULFILLED`: {
      //this is also edit charity as well
      const existingCharities = state.charities;
      currId = currId + 1;
      return {
        ...state,
        charities: {
          ...existingCharities,
          [payload.charityID ? payload.charityID : currId]: {
            ...existingCharities[payload.charityID],
            ...payload,
            charityID: payload.charityID ? payload.charityID : currId,
          },
        },
      };
    }
    case `${Add_Gross_Amount}_FULFILLED`: {
      const existingCharities = state.charities;
      return {
        ...state,
        charities: {
          ...existingCharities,
          [payload.charityID]: {
            ...payload,
          },
        },
      };
    }
    case `${Disclosure_Agree}_FULFILLED`: {
      const existingCheckbox = state.checkbox;
      return {
        ...state,
        checkbox: !existingCheckbox,
      };
    }
    case `${Reduce_Auto_RMD}_FULFILLED`: {
      const existingReduceAutoRMD = state.reduceAutoRMD;
      return {
        ...state,
        reduceAutoRMD: !existingReduceAutoRMD,
      };
    }
    case `${Delete_Charity}_FULFILLED`: {
      const existingCharities = state.charities;
      delete existingCharities[payload];
      return {
        ...state,
        charities: {
          ...existingCharities,
        },
      };
    }
    case `${Update_QCD_Amount}_FULFILLED`: {
      const { qcdSelectedFunds } = state;
      return {
        ...state,
        qcdSelectedFunds: {
          ...qcdSelectedFunds,
          [payload.fund.agreementID]: {
            selected: true,
            grossAmountDollars: payload.amount,
          },
        },
      };
    }
    case `${Delete_QCD_Fund}_FULFILLED`:
    case `${Add_QCD_Fund}_FULFILLED`: {
      const { qcdSelectedFunds } = state;
      const newSelectedFund = !qcdSelectedFunds[payload]?.selected || false;

      return {
        ...state,
        qcdSelectedFunds: {
          ...qcdSelectedFunds,
          [payload]: { selected: newSelectedFund },
        },
      };
    }
    case `${QCD_SUBMIT}_PENDING`: {
      return {
        ...state,
        QCDSuccess: false,
        QCDFailure: false,
        QCDLoading: true,
      };
    }
    case `${QCD_SUBMIT}_REJECTED`: {
      return {
        ...state,
        QCDSuccess: false,
        QCDFailure: true,
        QCDLoading: false,
      };
    }
    case `${QCD_SUBMIT}_FULFILLED`: {
      return {
        ...state,
        QCDSuccess: true,
        QCDFailure: false,
        QCDLoading: false,
        QCDTransactionSuccess: payload.body,
      };
    }
    case `${QCD_PRINT}_PENDING`: {
      return {
        ...state,
        QCDPrintSuccess: false,
        QCDPrintFailure: false,
        QCDPrintPending: true,
      };
    }
    case `${QCD_PRINT}_REJECTED`: {
      return {
        ...state,
        QCDPrintSuccess: false,
        QCDPrintFailure: true,
        QCDPrintPending: false,
      };
    }
    case `${QCD_PRINT}_FULFILLED`: {
      const blob = new Blob([payload.body], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      // link.download = 'QCD Confirmation Summary.pdf';
      link.click();
      window.URL.revokeObjectURL(url);
      return {
        ...state,
        QCDPrintSuccess: true,
        QCDPrintFailure: false,
        QCDPrintPending: false,
      };
    }
    case `${GET_QCD_TRADE_DATES}_PENDING`:
      return {
        ...state,
        qcdTradeDatesFailed: false,
        qcdTradeDatesSuccess: false,
        qcdTradeDatesLoading: true,
      };
    case `${GET_QCD_TRADE_DATES}_FULFILLED`:
      return {
        ...state,
        qcdTradeDatesFailed: false,
        qcdTradeDatesSuccess: true,
        qcdTradeDatesLoading: false,
        qcdTradeDates: payload.body,
      };
    case `${GET_QCD_TRADE_DATES}_REJECTED`:
      return {
        ...state,
        qcdTradeDatesFailed: true,
        qcdTradeDatesSuccess: false,
        qcdTradeDatesLoading: false,
        qcdTradeDates: {},
      };
    default:
      return state;
  }
}

export const getEligibleQcdTradeDates = (payload) => {
  return (dispatch) => {
    const action = createAction(GET_QCD_TRADE_DATES)(
      callApi(getEndpoint('qcdValidate'), { method: 'POST' }, payload)
    );
    dispatch(action);
  };
};

export const AddCharity = (charityObj) => {
  return (dispatch) => {
    const action = createAction(`${Add_Charity}_FULFILLED`)(charityObj);
    dispatch(action);
  };
};

export const AddGrossAmount = (charityObj) => {
  return (dispatch) => {
    const action = createAction(`${Add_Gross_Amount}_FULFILLED`)(charityObj);
    dispatch(action);
  };
};

export const DisclosureAgree = (charityObj) => {
  return (dispatch) => {
    const action = createAction(`${Disclosure_Agree}_FULFILLED`)(charityObj);
    dispatch(action);
  };
};

export const resetQCDFundsValue = () => {
  return (dispatch) => {
    const action = createAction(`${RESET_QCD_SELECTED_FUND}_FULFILLED`)();
    dispatch(action);
  };
};
export const ReduceAutoRMD = (charityObj) => {
  return (dispatch) => {
    const action = createAction(`${Reduce_Auto_RMD}_FULFILLED`)(charityObj);
    dispatch(action);
  };
};

export const DeleteCharity = (charityID) => {
  return (dispatch) => {
    const action = createAction(`${Delete_Charity}_FULFILLED`)(charityID);
    dispatch(action);
  };
};

export const AddQCDFund = (agreementID) => {
  return (dispatch) => {
    const action = createAction(`${Add_QCD_Fund}_FULFILLED`)(agreementID);
    dispatch(action);
  };
};

export const DeleteQCDFund = (agreementID) => {
  return (dispatch) => {
    const action = createAction(`${Delete_QCD_Fund}_FULFILLED`)(agreementID);
    dispatch(action);
  };
};

export const getQCDFunds = () => {
  return () => {
    const iraQCDSelectionEndpoint = getEndpoint('iraQCDSelection');
    return createAction(`${QCD_Fund_Endpoint}`)(
      callApi(`${iraQCDSelectionEndpoint}`)
    );
  };
};

export const updateQCDFundAmount = (fundInfo) => {
  return (dispatch) => {
    const action = createAction(`${Update_QCD_Amount}_FULFILLED`)(fundInfo);
    dispatch(action);
  };
};

export const executeQCD = (payload) => {
  return (dispatch) => {
    const action = createAction(`${QCD_SUBMIT}`)(
      callApi(getEndpoint('submitQCD'), { method: 'POST' }, payload)
    );
    dispatch(action);
  };
};

export const QCDPrintPDF = (id) => {
  return (dispatch) => {
    const action = createAction(`${QCD_PRINT}`)(
      callApi(`${getEndpoint('printQCD')}/${id}`, { method: 'GET' }, null, true)
    );
    dispatch(action);
  };
};
